import { useState } from "react";
import { getResponsesCsv } from "../utils/admin";
import { useNavigate } from "react-router-dom";

export default function Admin() {
  const navigate = useNavigate();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const handleDownloadCsv = async () => {
    try {
      const blob = await getResponsesCsv(startDate, endDate);
      if (!blob) {
        console.error("No CSV data received");
        return;
      }

      // Create a download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "responses.csv";
      document.body.appendChild(link);
      link.click();

      // Cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Failed to download CSV:", error);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('adminAuth');
    navigate('/');
  };

  return <div className="p-8">
    <div className="flex justify-between items-center mb-4">
      <h1 className="text-2xl font-bold">Admin Dashboard</h1>
      <button
        className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
        onClick={handleLogout}
      >
        Logout
      </button>
    </div>

    <div className="bg-white p-6 rounded-lg shadow-md mb-4">
      <h2 className="text-lg font-semibold mb-4">Date Filter</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div>
          <label htmlFor="startDate" className="block text-sm font-medium text-gray-700 mb-1">
            Start Date
          </label>
          <input
            id="startDate"
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-sky-500"
          />
        </div>
        <div>
          <label htmlFor="endDate" className="block text-sm font-medium text-gray-700 mb-1">
            End Date
          </label>
          <input
            id="endDate"
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-sky-500"
          />
        </div>
      </div>
      {(startDate || endDate) && (
        <button
          className="text-sm text-gray-600 hover:text-gray-800 underline"
          onClick={() => {
            setStartDate("");
            setEndDate("");
          }}
        >
          Clear filters
        </button>
      )}
    </div>

    <div className="flex gap-4">
      <button className="px-4 py-2 bg-sky-600 text-white rounded hover:bg-sky-700"
        onClick={handleDownloadCsv}
      >
        Download Responses CSV
      </button>
      <a
        href="/db-admin"
        target="_blank"
        rel="noopener noreferrer"
        className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 inline-block text-center"
      >
        Open Mongo Express
      </a>
    </div>
  </div>;
}
